import { useEffect } from "react";
import { Tour } from "./Projects";

interface Props {
  tour: Tour;
}

function Preview({ tour }: Props) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = tour.title;

    return () => {
      document.title = previousTitle;
    };
  }, [tour.title]);

  useEffect(() => {
    const faviconHref = tour.faviconImage?.trim();

    if (!faviconHref) {
      return;
    }

    const previousIcon = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
    const previousHref = previousIcon?.href;
    const iconElement = previousIcon ?? document.createElement("link");

    iconElement.setAttribute("rel", "icon");
    iconElement.setAttribute("href", faviconHref);

    if (!previousIcon) {
      document.head.appendChild(iconElement);
    }

    return () => {
      if (previousIcon && previousHref) {
        previousIcon.setAttribute("href", previousHref);
      } else if (!previousIcon) {
        iconElement.remove();
      }
    };
  }, [tour.faviconImage]);

  return (
    <div style={{ height: "100svh" }}>
      <iframe
        width="100%"
        height="100%"
        src={tour.src}
        frameBorder="0"
        allowFullScreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
  );
}

export default Preview;
